import {createContext} from "react";

const AuthenticationContext = createContext({});

export default AuthenticationContext;
